module.exports = __webpack_public_path__ + "img/Emptying.6706ae11.png";